import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col"; 
import { Heading ,T } from "../components/helpful";
import WCalendar from "../components/calendar";
import { Calendar } from "primereact/calendar";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { Tag } from "primereact/tag";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

/* The WeddingCalendar class in JavaScript renders a wedding calendar component with hotel availability
statuses. 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/
export default class WeddingCalendar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: <T value={"Wedding Calendar"} /> ,
      hotelImg: 0,
      desc: <T value={"Select your wedding Date"} />,
    };
  }

  subHeading = () => {
    return <>{this.state.desc}</>;
  }
  render() {

    const hotels = this.props.hotels;

    return (
      <div>
        <div className="">
          <div className="sticky-top">
            <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
          </div>

            <WCalendar />
            <Row className="px-3">
            <div className="d-flex justify-content-center my-5">
              <div className="">
                <Tag value="" className="color-key booked-status-1"></Tag>
                <span className=""><T value={"Already Booked"} /> </span>
              </div>
              <div className="mx-5">
                <Tag value="" className="color-key booked-status-2"></Tag>
                <span className=""> <T value={"Tentatively Booked"} /></span>
              </div>
              <div className="">
                <Tag value="" className="color-key booked-status-3"></Tag>
                <span className=""> <T value={"The Date Is Available"} /></span>
              </div>
            </div>
          </Row>
        </div>
      </div>
    );
  }
}
